import { Directive, Input } from '@angular/core';

/**
 * Helper directive to mark a mat-tab with a URL key.
 * Use this with the syncTabsWithUrl directive.
 *
 * Example:
 * <mat-tab label="Planning" urlKey="planning">...</mat-tab>
 */
@Directive({
  selector: 'mat-tab[urlKey]',
  standalone: false
})
export class TabUrlKeyDirective {
  @Input() urlKey!: string;
}
